export default {
  parameters: {
    landing_id: "TrNewMath",
  },
  new_social_proof: true,
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    title: "4 kısa sorumuza cevap verin ve ücretsiz matematik dersinizi alın!",
    button: "Hadi Başlayalım",
    imageMobile: {
      url: "/welcome/turkey_math_mob.png",
      style: {
        width: "100%",
      },
    },
    image: {
      url: "/welcome/turkey_math_desk.png",
      style: {
        height: "100%",
        "max-height": "100vh",
      },
    },
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title:
      "Eğitim platformumuza güvendiğiniz için teşekkür ederiz! Maalesef tabletler veya telefonlar derslerimizi almak için uygun değil. Bir dahaki sefere sizi sınıflarımızda görmekten mutluluk duyarız!",
  },
  quizRotateBySteps: {
    1: {
      question: "Çocuğunuz matematik hakkında ne düşünüyor?",
      image: {
        image_main: "/welcome/math_girl.webp",
        imageMobile: "/welcome/math_girl.webp",
        isMainImage: true,
        isVideo: false,
      },
      answers: [
        "Matematiği seviyor ve tam anlamıyla içinde!",
        "Biraz teşvike ihtiyacı var",
        "Zorlanıyor ve kaçınıyor",
        "Matematiği pek sevmiyor ama bunu değiştirmek istiyorum",
      ],
    },
    2: {
      question:
        "Çocuğunuzun matematik yolculuğundaki en büyük önceliğiniz nedir?",
      answers: [
        "Çocuğumun ilgisini canlı tutmak ve heyecanlandırmak",
        "Matematiğin hayatın bir parçası olduğunu göstermek",
        "Okulda başarılı olmasına yardımcı olmak",
        "Sıkıcı ve eski yöntemlerden kurtulmasını sağlamak",
      ],
    },
    3: {
      question:
        "Merak etmeyin, yanınızdayız. 100.000'den fazla ebeveyn, Kodland dersleri sayesinde çocuklarının matematiği sevmesini, ilgilerinin artmasını ve okulda başarılı olmalarını sağladı.",
      subtitle:
        "Ebeveynler için çocuklarının matematiği sevmesinin ne kadar önemli olduğunu biliyoruz.",
      image: {
        image_main: "/welcome/math_trustpilot.png",
        imageMobile: "/welcome/math_trustpilot.png",
        isMainImage: true,
        isVideo: false,
      },
      answers: ["Harika!", "Bu çok önemli! "],
    },
    4: {
      question:
        "Sizce öğrenimde sağlam bir akademik temel ne kadar önemli?",
      image: {
        image_main: "/welcome/math_boy.jpg",
        imageMobile: "/welcome/math_boy.jpg",
        isMainImage: true,
        isVideo: false,
      },
      answers: [
        "Çok güçlü bir akademik temel istiyorum",
        "Yarı yarıya — Yaratıcılığın da önemli olduğuna inanıyorum",
        "Katılım ve öğrenme keyfi, sınavlardan daha önemli",
        "Emin değilim, ama geleceğe hazır olmalarını istiyorum",
      ],
    },
    5: {
      question: "Çocuğunuzun öğrenme konusunda en çok sevdiği şey nedir?",
      answers: [
        "Eğlenceli oyunlar ve uygulamalı etkinlikler",
        "Net, adım adım açıklamalar",
        "Küçük gruplar ve bolca bireysel ilgi",
        "Yol gösteren ve ilham veren bir öğretmen",
        "Yukarıdakilerin hepsi"
      ],
    },
    6: {
      question:
        "Evet, matematik derslerimiz hem sizi hem de çocuğunuzu mutlu etmek için tasarlandı.",
      subtitle:
        "Sıcak, destekleyici bir öğretmen, onları tüm temel konularda eğlenceli ve oyunlaştırılmış bir yaklaşımla yönlendirecek!",
      image: {
        image_main: "/welcome/math_kids.webp",
        imageMobile: "/welcome/math_kids.webp",
        isMainImage: true,
        isVideo: false,
      },
      answers: ["Harika! Dersin zamanını seçin", "Harika, beni de yaz!"],
    },
    7: {
      title: "Deneme dersi için hangi saatte uygunsunuz?",
      image: {
        image_main: "/welcome/quiz_turkey_supermega_Social_proof_q3.png",
        imageMobile: "/welcome/quiz_turkey_supermega_Social_proof_q3.png",
        isMainImage: true,
        isVideo: false,
      },
      type: "timeslot",
      subtitle:
        "Özel dersinizi rezerve etmek için birkaç adım kaldı! Sizinle tanışmak için sabırsızlanıyoruz🥳",
      button: "Rezervasyon için tıklayın 🎁",
    },
    8: {
      image: {
        image_main: "/welcome/quiz_turkey_supermega_Social_proof_q6.png",
        imageMobile: "/welcome/quiz_turkey_supermega_Social_proof_q6.png",
        isMainImage: true,
        isVideo: false,
      },
      title: "Çocuğunuz kaç yaşında?",
      type: "age",
      subtitle: "Çocuğunuzun yaşına göre en eğlenceli kursu seçeceğiz",
      button: "İleri 🚀",
    },
    9: {
      title: "İsminizi girin",
      type: "parent_name",
      subtitle: "Bizim adımız Kodland, sizinki ne?👋",
      button: "Son adım! 🎉",
    },
    10: {
      title: "E-postanızı girin",
      type: "mail",
      subtitle: "Endişelenmeyin, spam gönderilmeyecek😅",
      button: "İleri 🚀",
    },
    11: {
      title: "Telefon numaranızı girin",
      type: "phone",
      subtitle:
        "Önemli konularda sizinle iletişime geçmek için kullanacağız 📞",
      button: "Neredeyse bitti 🔥",
    },
    12: {
      type: "computer",
      title: "Çalışabileceğiniz bir masaüstü/dizüstü bilgisayarınız var mı?",
    },
    13: {
      image: {
        image_main: "/welcome/quiz_turkey_supermega_Social_proof_q7.png",
        imageMobile: "/welcome/quiz_turkey_supermega_Social_proof_q7.png",
        isMainImage: true,
        isVideo: false,
      },
      title: "Çocuğunuzun adı nedir?",
      type: "child_name",
      subtitle: "Veriler korunmaktadır ve talebiniz üzerine silinecektir 🚨",
      button: "İleri 🚀",
    },
  },
};
